<template>
  <div class="app-container crm-detail business-detail">
    <el-card class="crm-detail-base" shadow="never">
      <el-row>
        <el-col :span="16">
          <span class="base-name">{{detail.orderNum}}</span>
        </el-col>
        <el-col :span="8" v-if="detail.id" align="right">
          <!--订单状态 10-待发货 1-->
          <el-button type="text" @click="handleAssign()">分配</el-button>
          <el-button type="text" v-if="detail.orderStatus === 10" @click="handleExpress">发货</el-button>
          <el-button type="text" v-if="detail.orderStatus === 20" @click="handleDelivery">确认交付</el-button>
        </el-col>
      </el-row>
      <div class="overflowH">
        <div class="base-item">
          <div class="title label">订单状态</div>
          <div class="value">{{detail.orderStatusDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">客户</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.customer(detail.customerId, '_blank')">{{detail.customerName}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">商机</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.business(detail.businessId, '_blank')">{{detail.businessName}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">合同编号</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.contract(detail.contractId, '_blank')">{{detail.contractNum}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">合同金额(元)</div>
          <div class="value">{{amountFormat(detail.contractAmount || 0)}}元</div>
        </div>
        <div class="base-item">
          <div class="title label">发货日期</div>
          <div class="value">{{detail.expressDate}}</div>
        </div>
        <div class="base-item">
          <div class="title label">交付日期</div>
          <div class="value">{{detail.deliveryDate}}</div>
        </div>
      </div>
    </el-card>
    <el-row :gutter="16">
      <el-col :span="16">
        <el-card class="crm-detail-main" v-if="detail.id" shadow="never">
          <el-tabs v-model="activeName" @tab-click="handleTabClick" :stretch="true">
            <el-tab-pane label="跟进记录" name="followPlan">
                <FollowAdd ref="followAddRef"  :targetId="detail.id" targetType="deliveryOrder"
                            @success="handleAfterFollowAdd"></FollowAdd>
                <div style="height: 473px">
                <FollowList :targetId="detail.id" targetType="deliveryOrder" ref="followListRef"></FollowList>
                </div>
            </el-tab-pane>
            <el-tab-pane label="订单信息" name="detail">
              <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="135px" :hide-required-asterisk="!editModel">
                <el-card shadow="never" class="el-card-simple card-item">
                  <div slot="header">
                    <span>基本信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="订单编号:">
                        <span class="value">{{detail.orderNum}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="订单状态:">
                        <span class="value" style="margin-right: 10px" >{{detail.orderStatusDesc}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="创建人:">
                        <span class="value" style="margin-right: 10px" >{{detail.createUserName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="创建时间:">
                        <span class="value" style="margin-right: 10px" >{{detail.createTime}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <el-card shadow="never"  class="el-card-simple card-item">
                  <div slot="header">
                    <span>合同信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="合同编号:" prop="customerId">
                        <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.contract(detail.contractId, '_blank')">{{detail.contractNum}}</el-link>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="合同金额（元）:">
                        <span class="value">{{amountFormat(detail.contractAmount || 0)}}元</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="24">
                      <el-form-item label="质保期限(年):">
                        <span class="value" v-if="detail.warrantyPeriod">{{detail.warrantyPeriod}}年</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="24">
                      <el-form-item label="质保说明:">
                        <span class="value">{{detail.warrantyDesc}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <el-card shadow="never"  class="el-card-simple card-item">
                  <div slot="header">
                    <span>产品信息</span>
                  </div>
                  <el-row :gutter="20" align="center">
                    <el-col :xs="24" :md="12" :lg="24">
                      <el-table :data="detail.contractCompositionList">
                        <el-table-column label="产品类型" align="center" prop="productType"/>
                        <el-table-column label="产品型号" align="center" prop="productModel"/>
                        <el-table-column label="合同用量" align="center" prop="contractUsage">
                          <template slot-scope="scope">
                            {{scope.row.contractUsage}}{{scope.row.usageUnit}}
                          </template>
                        </el-table-column>
                        <el-table-column label="备注" align="center" prop="remark"/>
                      </el-table>
                    </el-col>
                  </el-row>
                </el-card>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="项目信息" name="contact">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="text" @click="handleEdit"  v-if="!editModel">编辑</el-button>
                  <el-button type="primary" @click="handleProjectEditSave" v-if="editModel">保存</el-button>
                  <el-button  @click="editModel = false" v-if="editModel">取消</el-button>
                </el-col>
              </el-row>
              <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="135px" :hide-required-asterisk="!editModel">
                <el-card shadow="never"  class="el-card-simple card-item">
                  <div slot="header">
                    <span>基本信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="污水类型:" prop="sewageType">
                        <el-select v-if="editModel" v-model="updateData.sewageType" placeholder="请选择污水类型" clearable style="width:100%">
                          <el-option v-for="dict in wewageTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value" style="margin-right: 10px" >{{detail.sewageType}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="日处理量:" prop="dailyProcessCapacity">
                        <el-input v-if="editModel" v-model="updateData.dailyProcessCapacity" :maxlength="100" placeholder="请输入日处理量" clearable/>
                        <span v-else class="value">{{detail.dailyProcessCapacity}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="通量:" prop="flux">
                        <el-input v-if="editModel" v-model="updateData.flux" :maxlength="100" placeholder="请输入通量" clearable/>
                        <span v-else class="value">{{detail.flux}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <el-card shadow="never"  class="el-card-simple card-item">
                  <div slot="header">
                    <span>收货信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="收货人:" prop="receiverName">
                        <el-input v-if="editModel" v-model="updateData.receiverName" :maxlength="32" placeholder="请输入收货人" clearable/>
                        <span v-else class="value" @click="skipCustomerDetail(detail.receiverName)">{{detail.receiverName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="联系电话:" prop="receiverMobile">
                        <el-input v-if="editModel" v-model="updateData.receiverMobile" :maxlength="32" placeholder="请输入联系电话" clearable/>
                        <span v-else class="value">{{detail.receiverMobile}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="项目区域:" prop="area">
                        <el-cascader v-if="editModel" v-model="updateData.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
                        <!-- <span v-else class="value">{{detail.provinceName}}{{detail.cityName}}{{detail.regionName}}</span> -->
                        <span v-else class="value">{{detail.areaName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="项目地址:" prop="address">
                        <el-input v-if="editModel" v-model="updateData.address" :maxlength="64" placeholder="请输入详细地址" clearable/>
                        <span v-else class="value">{{detail.address}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <el-card v-if="detail.orderStatus !== 10" shadow="never"  class="el-card-simple card-item">
                  <div slot="header">
                    <span>发货信息</span>
                  </div>
                  <ExpressList :deliveryOrderId="detail.id" :editAble="true" @success="editExpressCallBack"/>
                </el-card>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="交付信息" name="delivery">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="text" @click="handleDeliverEdit"  v-if="!editModel">编辑</el-button>
                  <el-button type="primary" @click="handleDeliverEditSave" v-if="editModel">保存</el-button>
                  <el-button  @click="editModel = false" v-if="editModel">取消</el-button>
                </el-col>
              </el-row>
              <el-form :model="updateDeliverData" ref="updateDeliverForm" label-width="135px" :hide-required-asterisk="!editModel">
                <el-card shadow="never"  class="el-card-simple card-item">
                  <div slot="header">
                    <span>基本信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="24">
                      <el-form-item label="服务方式:" prop="serviceWay">
                        <el-radio-group v-if="editModel" v-model="updateDeliverData.serviceWay">
                            <el-radio label="1">线上</el-radio>
                            <el-radio label="2">线下</el-radio>
                        </el-radio-group>
                        <span v-else class="value">{{detail.serviceWayDesc}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="24">
                      <el-form-item label="交付内容:" prop="deliverContentList">
                        <el-checkbox-group v-if="editModel" v-model="updateDeliverData.deliverContentList">
                            <el-checkbox v-for="dict in deliverContentOptions" :key="dict.dictValue" :label="dict.dictLabel" :name="dict.dictValue"></el-checkbox>
                        </el-checkbox-group>
                        <span v-else class="value" style="margin-right: 10px" >{{detail.deliverContents}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="24">
                      <el-form-item label="项目风险:" prop="projectRisk">
                        <el-input
                          v-if="editModel"
                          type="textarea"
                          :autosize="{ minRows: 3, maxRows: 5}"
                          :maxlength="1000"
                          show-word-limit
                          v-model="updateDeliverData.projectRisk"
                          placeholder="请输入"
                          clearable/>
                        <span v-else class="value">{{detail.projectRisk}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
              </el-form>
            </el-tab-pane>
            <el-tab-pane :label="'服务(' + serviceCount + ')'" name="service">
              <!-- 服务单列表 -->
              <ServiceList ref="serviceListRef" :deliveryOrderId="detail.id" :customerId="detail.customerId" @after-query="handleAfterServiceQuery"/>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="crm-detail-follow" v-if="detail.id" shadow="never">
          <div class="label">负责人</div>
          <div class="crm-manager">
            <UserAvatar class="avatar" :url="detail.managerAvatar" :name="detail.managerName"/>
            <div class="name"><span class="value">{{detail.managerName}}</span></div>
          </div>
          <GroupMember :groupName="'团队'" :targetId="detail.id" :targetType="'deliveryOrder'"
                       :canAddGroupMemberFlag="detail.canAddGroupMemberFlag" @success="handleGroupMemberSuccess"/>
          <el-divider content-position="left"><span class="label">操作日志</span></el-divider>
          <div style="height: 534px">
            <OperateLogList ref="operateLogListRef" :targetId="detail.id" targetType="deliveryOrder"></OperateLogList>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <AssignDialog ref="assignDialogRef" @success="refreshDetailAndLog"></AssignDialog>
    <!-- 发货 -->
    <AddExpressDialog ref="addExpressDialogRef" @success="refreshDetailAndLog"/>
    <!-- 确认交付 -->
    <ConfirmDeliverDialog ref="confirmDeliverDialogRef" @success="refreshDetailAndLog"></ConfirmDeliverDialog>

  </div>
</template>

<script>
import {
  queryDeliveryDetail,
  editProject,
  editDelivery,
  logisticsCompanyList
} from "@/api/crm/order";
import FollowList from "@/views/crm/follow/followList";
import AddMember from "@/views/crm/components/addMember";
import ServiceList from "@/views/crm/service/serviceList";
import FollowAdd from "@/views/crm/follow/followAdd";
import OperateLogList from "@/views/crm/components/operateLogList";
import AssignDialog from "@/views/crm/components/assignDialog";
import ConfirmDeliverDialog from "./confirmDeliverDialog"
import ExpressList from "./expressList"

import UserAvatar from '@/views/system/user/userAvatar'
import { amountFormat, transferCascaderOptionsForProvince } from '@/utils/index'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {mapState} from 'vuex'
import {listAllLevelArea} from '@/api/crm/area'
import {validPhone} from "@/utils/validator";
import AddExpressDialog from "./addExpressDialog.vue"
import GroupMember from "@/views/crm/groupMember"

export default {
  name: "BusinessDetail",
  data() {
    return {
      amountFormat,
      // 遮罩层
      loading: true,
      detail: {},
      swot: {},
      activeName: "followPlan",
      editModel: false,
      serviceCount: 0, // 交付单数量
      areaOptions: [],
      logisticsCompanyList: [], // 物流公司
      deliverContentOptions: [], // 交付内容
      serviceWayOptions: [], // 服务方式
      wewageTypeOptions: [],
      updateData: { // 编辑项目
        id: null,
        remark: "",
        customerId: null,
        area: [],
        address: null,
        businessName: null,
        estimateDealAmount: undefined,
        estimateDealDate: null
      },
      serviceDataList: [],
      queryServiceParams: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      updateRules: {
        receiverName: [
          {required: true, message: '请输入收货人', trigger: 'blur'}
        ],
        receiverMobile: [
          {required: true, validator: validPhone, trigger: 'blur'}
        ],
        area: [
          {required: true, message: '请选择城市', trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请输入详细地址', trigger: 'blur'}
        ],
        // expressDate: [
        //   {required: true, message: '请选择发货日期', trigger: 'blur'}
        // ],
        dailyProcessCapacity: [
          {required: true, message: '请输入日处理量', trigger: 'blur'}
        ],
        sewageType: [
          {required: true, message: '请选择污水类型', trigger: 'blur'}
        ],
        flux: [
          {required: true, message: '请输入通量', trigger: 'blur'}
        ],
      },
      updateDeliverData: {
        serviceWay: null,
        deliverContentList: [],
        projectRisk: null
      },
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
    })
  },
  components: {
    FollowList,
    FollowAdd,
    OperateLogList,
    AssignDialog,
    UserAvatar,
    Treeselect,
    ServiceList,
    ConfirmDeliverDialog,
    AddMember,
    ExpressList,
    AddExpressDialog,
    GroupMember
  },
  created() {
    if (this.$route.params.id) {
      this.queryDetail()
    } else {
      this.msgError("无效的订单");
    }
    this.queryLogisticsCompanyList()
    this.getDicts("sewage_type").then(response => {
      this.wewageTypeOptions = response.data;
    });
    this.getDicts("deliver_content").then(response => {
      this.deliverContentOptions = response.data;
    });

    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  watch: {
    editModel (val) {
      if (!val) {
        this.resetForm("updateForm");
      }
    }
  },
  methods: {
    // 查询物流公司
    queryLogisticsCompanyList () {
      logisticsCompanyList().then( response => {
        this.logisticsCompanyList = response.data
      }).catch(error => {
      })
    },
    handleTabClick (tab) {
      this.editModel = false
      if (tab.name === 'service') {
        this.$refs.serviceListRef.queryList()
      }else {
        this.queryDetail()
      }
    },
    refreshDetailAndLog() {
      this.$refs["followAddRef"].queryAtList()
      this.queryDetail()
      this.refreshOperateLogList();
    },
    editExpressCallBack() {
      this.refreshOperateLogList();
    },
    queryDetail () {
      queryDeliveryDetail({id:this.$route.params.id}).then(response => {
        if (response.data) {
          this.detail = response.data
        } else {
          this.msgError("查询不到此订单");
        }
      }).catch(error => {
        this.detail = {}
      })
    },
    handleAfterFollowAdd () {
      this.$refs.followListRef.refresh()
      this.queryDetail()
    },
    refreshOperateLogList () {
      this.$refs.operateLogListRef.refresh()
    },
    handleAfterServiceQuery (serviceList) {
      this.serviceCount = serviceList.length;
    },
    // 编辑项目信息
    handleEdit () {
      this.updateData = JSON.parse(JSON.stringify(this.detail))
      this.updateData.area = []
      if(this.detail.provinceCode){
        this.updateData.area.push(this.detail.provinceCode)
      }
      if(this.detail.cityCode){
        this.updateData.area.push(this.detail.cityCode)
      }
      if(this.detail.regionCode){
        this.updateData.area.push(this.detail.regionCode)
      }
      this.editModel = true
    },
    // 编辑交付信息
    handleDeliverEdit () {
      this.updateDeliverData = JSON.parse(JSON.stringify(this.detail))
      this.$set(this.updateDeliverData, 'deliverContentList', this.detail.deliverContentList || [])
      this.$set(this.updateDeliverData, 'serviceWay', this.detail.serviceWay  ? this.detail.serviceWay.toString() : '')
      this.editModel = true
    },
    skipCustomerDetail(id) {
      this.$router.push("/crm/customer/detail/" + id);
    },
    skipContactDetail(id) {
      this.$router.push("/crm/contact/detail/" + id);
    },
    // 编辑项目信息
    handleProjectEditSave () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          this.updateData.provinceCode = this.updateData.area && this.updateData.area.length > 0 ? this.updateData.area[0] : null
          this.updateData.cityCode = this.updateData.area && this.updateData.area.length > 1 ? this.updateData.area[1] : null
          this.updateData.regionCode = this.updateData.area && this.updateData.area.length > 2 ? this.updateData.area[2] : null
          editProject(this.updateData).then(response => {
            this.refreshDetailAndLog();
            this.editModel = false
            loading.close();
            this.msgSuccess("更新成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    handleDeliverEditSave () {
      this.$refs['updateDeliverForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          editDelivery(this.updateDeliverData).then(response => {
            this.refreshDetailAndLog();
            this.editModel = false
            loading.close();
            this.msgSuccess("更新成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.singleAssign("deliveryOrder", this.detail.id)
    },
    // 发货
    handleExpress() {
      this.$refs.addExpressDialogRef.open(this.detail.id)
    },
    // 确认交付
    handleDelivery(row) {
        this.$refs.confirmDeliverDialogRef.open(this.detail.id)
    },
    handleGroupMemberSuccess(userId) {
      if (this.currentUserId === userId) {
        this.queryDetail()
      }
      this.refreshOperateLogList()
      if (this.$refs.followAddRef) {
        this.$refs.followAddRef.queryAtList()
      }
    },
  }
};
</script>
<style lang='scss' scoped>
.card-item {
  border-radius: 6px;
  padding: 20px;
  border: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
.title{
  text-align: center;
}
  .business-detail {
    .closeFlagInfo {
      cursor: default;
      color: black;
    }
    .group-member-add-btn {
      width: 40px;
      height: 40px;
      text-align: center;
      border-radius: 50%;
      padding: 0 0 0 2px;
      position: absolute;
      top: -12px;
    }

    .group-member {
      width: 120px;
      margin-bottom: 20px;
      height: 40px;

      .avatar {
        float: left;
      }

      .name {
        margin-left: 45px;
        line-height: 50px;
        margin-top: -12px;
      }

      .value {
        width: 75px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .group-member-remove-btn {
        margin-left: -5px;
        cursor: pointer;
        position: absolute;
      }
    }
  }
</style>
